var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #152839;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300,
    cy: 300,
    r: 300
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.66,473.52h-139.32c-61.83,0-112.14-50.31-112.14-112.14v-122.77c0-61.83,50.31-112.13,112.14-112.13h139.32c61.83,0,112.13,50.3,112.13,112.13v122.77c0,61.83-50.31,112.14-112.13,112.14ZM230.34,151.4c-48.09,0-87.21,39.12-87.21,87.21v122.77c0,48.09,39.12,87.22,87.21,87.22h139.32c48.09,0,87.21-39.12,87.21-87.22v-122.77c0-48.09-39.12-87.21-87.21-87.21h-139.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,399.82c-55.04,0-99.82-44.78-99.82-99.82s44.77-99.82,99.82-99.82,99.82,44.77,99.82,99.82-44.78,99.82-99.82,99.82ZM300,225.1c-41.3,0-74.9,33.6-74.9,74.9s33.6,74.9,74.9,74.9,74.9-33.6,74.9-74.9-33.6-74.9-74.9-74.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419,203.25c0,11.43-9.27,20.71-20.71,20.71s-20.72-9.27-20.72-20.71,9.28-20.72,20.72-20.72,20.71,9.27,20.71,20.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon1);
export default __webpack_public_path__ + "static/media/instagram_icon 1.0169871cd9868f41569abd3663bac0f6.svg";
export { ForwardRef as ReactComponent };